/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Status_Review_TracksInputs */



/**
* | output |
* | --- |
* | "Publishing review results for individual tracks." |
*
* @param {Work_Order_Publish_Status_Review_TracksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_status_review_tracks = /** @type {((inputs?: Work_Order_Publish_Status_Review_TracksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Status_Review_TracksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publication des résultats de révision pour les pistes individuelles.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veröffentlichung der Rezensionen einzelner Titel.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblicazione dei risultati delle revisioni per le singole tracce.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Результаты рецензирования публикаций по отдельным направлениям.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publicación de resultados de revisión de pistas individuales.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发布各曲目的评审结果。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("個々のトラックのレビュー結果を公開します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अलग-अलग ट्रैक के लिए समीक्षा परिणामों का प्रकाशन।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Publicação dos resultados das avaliações para cada faixa individual.")
	return /** @type {LocalizedString} */ ("Publishing review results for individual tracks.")
});